import { Endpoint, Entity } from '@rest-hooks/rest';
import { BaseAuthenticationResource } from '../resources/BaseAuthenticationResource';

interface VariableParams {
  variableId: number;
  applicationNumber: string;
  applicationXml: string;
}

interface VariableResult {
  variableId?: number;
  applicationNumber?: string;
  result?: string;
}
class VariableResultEntity extends Entity implements VariableResult {
  readonly variableId?: number;
  readonly applicationNumber?: string;
  readonly result?: string;

  pk() {
    return `${this.variableId}-${this.applicationNumber}`;
  }
}

async function fetchWithAuth(url: string, options: RequestInit): Promise<Response> {
  const init = BaseAuthenticationResource.getFetchInit(options);
  return fetch(url, init);
}

export const VariableResultPreview = new Endpoint(
  (params: VariableParams | null): Promise<VariableResult | undefined> => {
    if (
      params == null ||
      !params.variableId ||
      !params.applicationNumber ||
      !params.applicationXml
    ) {
      return new Promise((res, rej) => rej(undefined));
    }
    const { variableId, applicationNumber, applicationXml } = params;
    return fetchWithAuth(`/api/variables/${variableId}/evaluate`, {
      method: 'POST',
      body: JSON.stringify({
        applicationNumber: applicationNumber,
        applicationXmlString: applicationXml
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.text())
      .then((result) => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(result, 'application/xml');
        const message = xml.querySelector('message')?.textContent;
        return { ...params, result: message ?? undefined } as VariableResult;
      });
  },
  {
    schema: VariableResultEntity
  }
);
